import React from 'react';
import { Link } from 'react-router-dom';

const BannerSection = () => {
  return (
    <section className="banner__section section--padding pt-0">
      <div className="container">
        <div className="row row-cols-lg-2 row-cols-md-2 row-cols-sm-2 row-cols-1 mb--n30">
          <div className="col mb-30">
            <div className="banner__items position__relative">
              <Link className="banner__items--thumbnail display-block" to="/shop">
                <img 
                  className="banner__items--thumbnail__img display-block" 
                  src={'/assets/img/banner/banner1.png'} 
                  alt="banner-img" 
                />
                <div className="banner__items--content">
                  <h2 className="banner__items--content__title text__secondary">Fresh Fruits</h2>
                  <p className="banner__items--content__desc text-white">
                    Discover our range of fresh fruits, handpicked for quality and taste. Seasonal offers up to 10% off!
                  </p>
                  <span className="btn banner__items--content__btn">Shop Now</span>
                </div>
              </Link>
            </div>
          </div>
          <div className="col mb-30">
            <div className="banner__items position__relative">
              <Link className="banner__items--thumbnail display-block" to="/shop">
                <img 
                  className="banner__items--thumbnail__img display-block" 
                  src={'/assets/img/banner/banner2.png'} 
                  alt="banner-img" 
                />
                <div className="banner__items--content">
                  <h2 className="banner__items--content__title text__secondary">Green Collards</h2>
                  <p className="banner__items--content__desc text-black">
                    Explore our selection of green collards and micro greens, perfect for healthy meals. Save 10% today!
                  </p>
                  <span className="btn banner__items--content__btn">Shop Now</span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerSection;
